import { createActions, createReducer } from "reduxsauce";

export const { Types, Creators } = createActions({
  vacancyCandidatesRequest: ["filter"],
  vacancyCandidatesRequestSuccess: ["vacancies", "isLoading"],
  vacancyCandidatesRequestFail: ["isLoading", "error"],

  candidatesFromRequest: ["payload", "page"],
  candidatesFromSuccess: ["candidates", "isLoading"],
  candidatesFromFail: ["isLoading", "error"],

  candidatesManagerRequest: ["candidates", "kindOfAction", "vacancyId", "stageId", "stageType"],
  candidatesManagerSuccess: ["isLoading"],
  candidatesManagerFail: ["isLoading", "error"],

  candidatesDispatchManagerRequest: [
    "candidates",
    "kindOfAction",
    "vacancyId",
    "enabledSendToCandidates",
    "feedback",
    "stageId"
  ],
  candidatesDispatchManagerSuccess: ["isLoading"],
  candidatesDispatchManagerFail: ["isLoading", "error"],

  candidateShowRequest: ["candidateId", "vacancyId"],
  candidateShowSuccess: ["candidate", "isLoading"],
  candidateShowFail: ["error"],

  candidatesScheduleEnterviewRequest: ["candidates", "vacancyId", "kindOfAction", "stageId"],
  candidatesScheduleEnterviewSuccess: ["isLoading"],
  candidatesScheduleEnterviewFail: ["isLoading", "error"],

  candidatesExportRequest: ["candidates", "vacancyId"],
  candidatesExportSuccess: ["payload"],
  candidatesExportFail: ["error"],

  candidatesExportPersonalInformationRequest: ["candidates", "vacancyId"],
  candidatesExportPersonalInformationSuccess: ["payload"],
  candidatesExportPersonalInformationFail: ["error"],

  candidatesPasswordResetRequest: ["candidates", "vacancyId"],
  candidatesPasswordResetSuccess: ["payload"],
  candidatesPasswordResetFail: ["error"],

  candidatesAddCandidateRequest: ["candidate", "vacancyId"],
  candidatesAddCandidateSuccess: ["payload"],
  candidatesAddCandidateFail: ["error"],
});

const INITIAL_STATE = {
  vacancies: [],
  isLoading: true,
  candidates: [],
  vacancy: {}
};

const vacancyCandidatesRequest = state => ({
  ...state,
  isLoading: true
});
const vacancyCandidatesRequestSuccess = (state, vacancies) => ({
  ...state,
  ...vacancies,
  isLoading: false
});
const vacancyCandidatesRequestFail = (state, error) => ({
  ...INITIAL_STATE,
  isLoading: false,
  ...error
});

const candidatesFromRequest = (state) => ({ ...state, isLoading: true });
const candidatesFromSuccess = (state, candidates) => ({
  ...state,
  ...candidates,
  isLoading: false
});
const candidatesFromRequestFail = (state, error) => ({
  ...state,
  isLoading: false,
  ...error
});

const candidatesManagerRequest = state => ({
  ...INITIAL_STATE,
  isLoading: true
});
const candidatesManagerSuccess = (state, vacancies, kindOfAction, stageId, stageType) => ({
  ...state,
  ...vacancies,
  ...kindOfAction,
  ...stageId,
  ...stageType,
  isLoading: false
});
const candidatesManagerFail = (state, error) => ({
  ...state,
  isLoading: false,
  ...error
});

const candidatesDispatchManagerRequest = state => ({
  ...state,
  isLoading: true
});
const candidatesDispatchManagerSuccess = (state, vacancies, kindOfAction) => ({
  ...state,
  ...vacancies,
  ...kindOfAction,
  isLoading: false
});
const candidatesDispatchManagerFail = (state, error) => ({
  ...state,
  isLoading: false,
  ...error
});

const candidateShowRequest = () => ({ ...INITIAL_STATE, isLoading: true });
const candidateShowSuccess = (state, candidate) => ({
  ...state,
  ...candidate,
  isLoading: false
});
const candidateShowFail = (state, error) => ({
  ...state,
  isLoading: false,
  ...error
});
const candidatesScheduleEnterviewRequest = state => ({
  ...INITIAL_STATE,
  isLoading: true
});

const candidatesScheduleEnterviewSuccess = (
  state,
  vacancies,
  kindOfAction
) => ({});

const candidatesScheduleEnterviewFail = (state, error) => ({
  ...state,
  isLoading: false,
  ...error
});

const candidatesExportRequest = (state) => ({
  ...state,
  isLoading: true
})

const candidatesExportSuccess = (state, payload) => ({
  ...state,
  isLoading: false
})

const candidatesExportFail = (state, error) => ({
  ...state,
  ...error,
  isLoading: false
})

const candidatesExportPersonalInformationRequest = (state) => ({
  ...state,
  isLoading: true
})

const candidatesExportPersonalInformationSuccess = (state, payload) => ({
  ...state,
  isLoading: false
})

const candidatesExportPersonalInformationFail = (state, error) => ({
  ...state,
  ...error,
  isLoading: false
})

const candidatesPasswordResetRequest = (state) => ({
  ...state,
  isLoading: true
})

const candidatesPasswordResetSuccess = (state, payload) => ({
  ...state,
  isLoading: false
})

const candidatesPasswordResetFail = (state, error) => ({
  ...state,
  ...error,
  isLoading: false
})

const candidatesAddCandidateRequest = (state) => ({
  ...state,
  isLoading: true
})

const candidatesAddCandidateSuccess = (state, payload) => ({
  ...state,
  isLoading: false
})

const candidatesAddCandidateFail = (state, error) => ({
  ...state,
  ...error,
  isLoading: false
})

export default createReducer(INITIAL_STATE, {
  [Types.VACANCY_CANDIDATES_REQUEST]: vacancyCandidatesRequest,
  [Types.VACANCY_CANDIDATES_REQUEST_SUCCESS]: vacancyCandidatesRequestSuccess,
  [Types.VACANCY_CANDIDATES_REQUEST_FAIL]: vacancyCandidatesRequestFail,

  [Types.CANDIDATES_FROM_REQUEST]: candidatesFromRequest,
  [Types.CANDIDATES_FROM_SUCCESS]: candidatesFromSuccess,
  [Types.CANDIDATES_FROM_FAIL]: candidatesFromRequestFail,

  [Types.CANDIDATES_MANAGER_REQUEST]: candidatesManagerRequest,
  [Types.CANDIDATES_MANAGER_SUCCESS]: candidatesManagerSuccess,
  [Types.CANDIDATES_MANAGER_FAIL]: candidatesManagerFail,

  [Types.CANDIDATES_DISPATCH_MANAGER_REQUEST]: candidatesDispatchManagerRequest,
  [Types.CANDIDATES_DISPATCH_MANAGER_SUCCESS]: candidatesDispatchManagerSuccess,
  [Types.CANDIDATES_DISPATCH_MANAGER_FAIL]: candidatesDispatchManagerFail,

  [Types.CANDIDATE_SHOW_REQUEST]: candidateShowRequest,
  [Types.CANDIDATE_SHOW_SUCCESS]: candidateShowSuccess,
  [Types.CANDIDATE_SHOW_FAIL]: candidateShowFail,
  [Types.CANDIDATES_SCHEDULE_ENTERVIEW_REQUEST]: candidatesScheduleEnterviewRequest,
  [Types.CANDIDATES_SCHEDULE_ENTERVIEW_SUCCESS]: candidatesScheduleEnterviewSuccess,
  [Types.CANDIDATES_SCHEDULE_ENTERVIEW_FAIL]: candidatesScheduleEnterviewFail,

  [Types.CANDIDATES_EXPORT_REQUEST]: candidatesExportRequest,
  [Types.CANDIDATES_EXPORT_SUCCESS]: candidatesExportSuccess,
  [Types.CANDIDATES_EXPORT_FAIL]: candidatesExportFail,

  [Types.CANDIDATES_EXPORT_PERSONAL_INFORMATION_REQUEST]: candidatesExportPersonalInformationRequest,
  [Types.CANDIDATES_EXPORT_PERSONAL_INFORMATION_SUCCESS]: candidatesExportPersonalInformationSuccess,
  [Types.CANDIDATES_EXPORT_PERSONAL_INFORMATION_FAIL]: candidatesExportPersonalInformationFail,

  [Types.CANDIDATES_PASSWORD_RESET_REQUEST]: candidatesPasswordResetRequest,
  [Types.CANDIDATES_PASSWORD_RESET_SUCCESS]: candidatesPasswordResetSuccess,
  [Types.CANDIDATES_PASSWORD_RESET_FAIL]: candidatesPasswordResetFail,

  [Types.CANDIDATES_ADD_CANDIDATE_REQUEST]: candidatesAddCandidateRequest,
  [Types.CANDIDATES_ADD_CANDIDATE_SUCCESS]: candidatesAddCandidateSuccess,
  [Types.CANDIDATES_ADD_CANDIDATE_FAIL]: candidatesAddCandidateFail,
});
